import { useEffect, useRef } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { message, Spin } from 'antd';

/**
 * 活动链接重定向页面
 * 用户访问 /c/{campaignCode} 时，重定向到注册页面并带上活动码
 */
const CampaignRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasExecuted = useRef(false);

  // 获取当前语言
  const lang = localStorage.getItem('lang') || 'en';
  const t = (zh, en) => (lang === 'zh' ? zh : en);

  useEffect(() => {
    if (hasExecuted.current) return;
    hasExecuted.current = true;

    if (code) {
      // 存储活动码到 localStorage，注册时会使用
      localStorage.setItem('campaign_code', code);
      
      // 检查是否有推荐码（商户邀请）
      const referrerCode = searchParams.get('ref');
      if (referrerCode) {
        localStorage.setItem('referrer_code', referrerCode);
      }

      // 检查是否已登录
      const token = localStorage.getItem('user_token');
      if (token) {
        // 已登录，提示用户
        message.info(t('您已登录，活动链接仅对新用户注册有效', 'You are already logged in. Campaign link is only valid for new user registration.'));
        navigate('/dashboard');
      } else {
        // 未登录，跳转到注册页面
        message.success(t('活动链接已识别，请注册参与活动', 'Campaign link recognized. Please register to participate.'));
        navigate('/register?campaign=' + code + (referrerCode ? '&ref=' + referrerCode : ''));
      }
    } else {
      navigate('/');
    }
  }, [code, navigate, searchParams, t]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: 16
    }}>
      <Spin size="large" />
      <span style={{ color: '#666' }}>{t('正在跳转...', 'Redirecting...')}</span>
    </div>
  );
};

export default CampaignRedirect;
